import React from "react";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import InfoItem from "../../components/InfoItem";
import ImageButton from "../../components/ImageButton";
import {
  appointmentPostAction,
  getAppoitmentList,
} from "../../actions/appointment";
import { formatDate } from "../../utils/helper";

const AppointmentDetailPopup = ({
  closePopup,
  details,
  startDate,
  endDate,
  setIsLoading,
  refreshCalendar,
}) => {
  const dispatch = useDispatch();
  return (
    <Modal size="lg" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Appointment Details</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex justify-content-end">
          <ImageButton
            text="Delete"
            icon={faTrash}
            isDelete="delete"
            onClick={() => {
              setIsLoading(true);
              let params = {
                params: {
                  action: "deleteAppointment",
                  id: details.id,
                  event_id: details.event_id,
                },
              };
              dispatch(
                appointmentPostAction(params, () => {
                  closePopup();
                  window.location.reload();
                })
              );
            }}
          />
        </div>
        <InfoItem title="Title" value={details.title} />
        <InfoItem title="Description" value={details.description} />
        <InfoItem title="Start Date" value={formatDate(details.start_date)} />
        <InfoItem title="End Date" value={formatDate(details.end_date)} />
        <InfoItem title="patient Name" value={details.patient_name} />
        <div className="d-flex ">
          <InfoItem title="Url" value={details.url} />
          <button
            className="btn-orange btn ml-2"
            onClick={() => window.open(details.url, "_blank")}
          >
            {" "}
            Join
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AppointmentDetailPopup;
